export enum TEXT_COLOR_CLASS {
    GREY = "cx-text-grey",
    GREEN = "cx-text-green"
}

export enum STATUS {
    OPEN = "OPEN",
    CLOSED = "CLOSED",
    INPROCESS = "INPROCESS"
}

export enum STATUS_NAME {
    OPEN = "Open",
    CLOSED = "Closed",
    INPROCESS = "INPROCESS"
}

export enum LAUNCH_CALLER {
    CUSTOMER_TICKETING_REOPEN = "CUSTOMER_TICKETING_REOPEN",
    CUSTOMER_TICKETING_CLOSE = "CUSTOMER_TICKETING_CLOSE",
    CUSTOMER_TICKETING_CREATE = "CUSTOMER_TICKETING_CREATE"
}